import { Grid } from "@mui/material";
import BlackCardInfo from "../../typographies/BlackCardInto";
import dayjs from "dayjs";
import { useStoreContext } from "../../..";
import { Measurement } from "../../../models/Measurements";

const VaccinationList = ({ items }: { items: Measurement[] }) => {
  const { fieldStore } = useStoreContext();
  if (!items) {
    return null;
  }

  return (
    <>
      {items.map((item, index) => (
        <Grid key={index} container>
          <Grid item xs={4}>
            <BlackCardInfo text={dayjs(item.date).format("YYYY-MM-DD")} />
          </Grid>
          <Grid item xs={8}>
            <BlackCardInfo
              text={fieldStore.mappedVaccines?.get(Number(item.value)) || ""}
            />
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default VaccinationList;
